import {PropsWithChildren} from "react";
import {CreateStoreServiceProvider} from ".";

export function CreateServiceContextWrapper({children}: PropsWithChildren) {
  return <CreateStoreServiceProvider>{children}</CreateStoreServiceProvider>;
}
